import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';
import css_248z from './hero-banner.scss.js';

class HeroBanner extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.template = 'stories';
        this.containerClassNames = '';
    }
    renderPressReleases() {
        return x `<div class="hero-banner ${this.containerClassNames}"><div class="hero-content-container ${this.template}"><slot name="date"></slot><slot name="title"></slot></div></div>`;
    }
    renderDefault() {
        return x `<div class="hero-banner ${this.containerClassNames}"><div class="hero-image-container"><slot name="image"></slot></div><div class="hero-content-container"><slot name="date"></slot><slot name="title"></slot><slot name="description"></slot></div></div>`;
    }
    render() {
        this.containerClassNames = getStyleClassNames({
            isRtl: this.isRtl,
        });
        const templates = {
            'press-releases': this.renderPressReleases(),
            stories: this.renderDefault(),
        };
        if (this.template) {
            return templates[this.template];
        }
        return this.renderDefault;
    }
}
HeroBanner.styles = css_248z;
__decorate([
    n({ type: Boolean })
], HeroBanner.prototype, "isRtl", void 0);
__decorate([
    n({ type: String })
], HeroBanner.prototype, "template", void 0);
customElements.define('hero-banner', HeroBanner);

export { HeroBanner };
